module.exports = __webpack_public_path__ + "static/media/back-green.34c3080b.png";